
































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import OperadoraConvenioStore from '@/components/OperadoraConvenio/Store/OperadoraConvenioStore'

@Component
export default class ViewSuporteEquipamentos extends Vue {
  loadHospital: boolean = false
  loadConveniosOperadora: boolean = false
  loadUpdateConveniosOperadora: boolean = false

  get getOperadoraConvenioStore() {
    return getModule(OperadoraConvenioStore, this.$store)
  }

  get loadingConveniosOperadora() { return this.loadConveniosOperadora }
  set loadingConveniosOperadora(value: boolean) { this.loadConveniosOperadora = value }
  get loadingUpdateConveniosOperadora() { return this.loadUpdateConveniosOperadora }
  set loadingUpdateConveniosOperadora(value: boolean) { this.loadUpdateConveniosOperadora = value }
  get loadingHospital() { return this.loadHospital }
  set loadingHospital(value: boolean) { this.loadHospital = value }
  get hospitalId() { return this.getOperadoraConvenioStore.hospitalId }
  set hospitalId(value: string) { this.getOperadoraConvenioStore.setHospitalId(value) }
  get hospitais() { return this.getOperadoraConvenioStore.hospitais }

  get conveniosOperadoraHeaders() {
    return [
      { text: 'Convênio', align: 'left', value: 'convenioNome', sortable: false },
      { text: '', align: 'center', value: '', sortable: false },
      { text: 'Operadora', align: 'left', value: '', sortable: false },
    ]
  }

  get conveniosOperadora() { return this.getOperadoraConvenioStore.conveniosOperadora }
  get searchConvenio() { return this.getOperadoraConvenioStore.searchConvenio }
  set searchConvenio(value: string) { this.getOperadoraConvenioStore.setSearchConvenio(value) }

  async hospitalChange(hospitalId: string) {
    this.getOperadoraConvenioStore.clearSearchConvenio()
    this.getOperadoraConvenioStore.clearConveniosOperadora()
    this.getOperadoraConvenioStore.clearOperadoras()
    this.getOperadoraConvenioStore.clearConvenios()
    this.getOperadoraConvenioStore.setHospitalId(hospitalId)

    this.loadingConveniosOperadora = true
    await this.getOperadoraConvenioStore.getOperadoraConvenio(hospitalId)
    await this.getOperadoraConvenioStore.getConvenioOperadoras(hospitalId)
    this.loadingConveniosOperadora = false
  }

  async updateConveniosOperadora() {
    this.loadingUpdateConveniosOperadora = true
    const response = await this.getOperadoraConvenioStore.upsertOperadoraConvenio()

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao gravar as alterações ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingUpdateConveniosOperadora = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Alterações gravadas com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingUpdateConveniosOperadora = false
  }

  operadoraChange(convenio: any, operadora: any) {
    const payload = {
      operadoraId: operadora ? operadora.operadoraId : '',
      operadoraNome: operadora ? operadora.operadoraNome : '',
      convenioId: convenio.convenioId,
      convenioNome: convenio.convenioNome,
      convenioRegistroANS: operadora ? operadora.registroAns : '',
    }
    this.getOperadoraConvenioStore.changeConveniosOperadora(payload)
  }

  adicionarOperadora() {
    this.getOperadoraConvenioStore.setModal({ name: 'operadora', value: true })
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    // @ts-ignore
    await this.getOperadoraConvenioStore.getHospitais(this.$user.profile.sub)
    EventBus.$emit('clearLoadingRequest')
  }

  beforeDestroy() {
    this.getOperadoraConvenioStore.clearOperadoras()
    this.getOperadoraConvenioStore.clearConvenios()
    this.getOperadoraConvenioStore.clearGrupoHospitais()
    this.getOperadoraConvenioStore.clearConveniosOperadora()
    this.getOperadoraConvenioStore.clearHospitais()
    this.getOperadoraConvenioStore.clearHospitalId()
  }
}
